import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Button } from '@/shared/ui';
import {
  LEGAL_DOC_URLS,
  persistCookieConsent,
  readCookieConsent,
} from '@/shared/lib/legal/docs';

/** Cookie notice for visitors who have not accepted them yet. Hidden on /register and /app/consents — those forms have their own checkbox. */
export function CookieConsentBanner() {
  const { t } = useTranslation();
  const location = useLocation();
  const [accepted, setAccepted] = useState(readCookieConsent);

  if (accepted || location.pathname === '/register' || location.pathname === '/app/consents') {
    return null;
  }

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-surface/95 px-4 py-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] backdrop-blur"
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-label={t('cookies.bannerTitle')}
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-text-secondary">
          <Trans
            i18nKey="cookies.bannerText"
            components={{
              doc: (
                <a
                  href={LEGAL_DOC_URLS.officialSite}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium text-primary-600 underline hover:text-primary-700"
                />
              ),
            }}
          />
        </p>
        <Button
          type="button"
          size="sm"
          className="shrink-0"
          onClick={() => {
            persistCookieConsent();
            setAccepted(true);
          }}
          data-testid="cookie-consent-accept"
        >
          {t('cookies.accept')}
        </Button>
      </div>
    </div>
  );
}
